import { BaseIp } from "./ApiURL";


//Ebooks
export const apiBooksPath = BaseIp + "api/Books/";

//Q Paper
export const apiQpaperPath = BaseIp + "api/Qpaper/";


//Syllabus

export const apiSyllabusPath = BaseIp + "api/Syllabus/";

//FAQ
export const apiFaqPath = BaseIp + "api/FAQ/";